import SharedReactTable from "components/shared/reactTable";
import { ProvideScrollPosition } from "contexts/scrollPosition";
import { paths } from "helpers/paths";
import { isDeletedColumn, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

function ItemChangePointsAddresses(props) {
    useEffect(() => {
        return () => props.clearParams();
    }, []);

    const tableColumns = useMemo(() => {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                sortable: true,
                Cell: ({ value, row: { original } }) => {
                    return <Link to={paths.itemChangePointsShow(original.id)}>{value}</Link>;
                },
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
            isDeletedColumn(),
            {
                Header: "",
                width: 50,
                accessor: "action",
                sortable: false,
                notExportable: true,
                Cell: ({ row }) => (
                    <div
                        className="btn btn-xs btn-outline-primary"
                        onClick={() => {
                            props.onChange({ name: "mapObject", value: row.original });
                            props.back();
                        }}
                    >
                        Выбрать
                    </div>
                ),
            },
        ];
    }, []);

    return (
        <ProvideScrollPosition>
            <SharedReactTable
                {...props}
                isNotExportable
                wrapCname="flex-1"
                getList={props.getList}
                columns={tableColumns}
            />
        </ProvideScrollPosition>
    );
}

export default tableContainer(ItemChangePointsAddresses, "select-item-change-points");
